// extracted by mini-css-extract-plugin
export default {"Title":"OfferStepIndicator_Title__fWy4c","Number":"OfferStepIndicator_Number__QI66i","Box":"OfferStepIndicator_Box__y+TQI","Highlighted":"OfferStepIndicator_Highlighted__2BEl-"};